import { render, staticRenderFns } from "./edit-framework.vue?vue&type=template&id=50c52c09"
import script from "./edit-framework.vue?vue&type=script&lang=js"
export * from "./edit-framework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports